import { useState, useCallback } from "react";
import logger from "../utils/logger";

function fmtErr(detail) {
  if (!detail) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function useMarketplace(api, fetchAchievements) {
  const [marketplaceData, setMarketplaceData] = useState({ items: [], available_coupons: [], available_tiers: [], redemptions: [] });
  const [marketplaceFilter, setMarketplaceFilter] = useState("all");
  const [redeeming, setRedeeming] = useState(null);
  const [showMarketplace, setShowMarketplace] = useState(false);
  const [showRedemptionSuccess, setShowRedemptionSuccess] = useState(null);

  const fetchMarketplace = useCallback(async () => {
    try { const r = await api.get("/marketplace"); setMarketplaceData(r.data); }
    catch (e) { logger.error("Fetch marketplace:", e); }
  }, [api]);

  const redeemCoupon = useCallback(async (itemId, couponCode) => {
    setRedeeming(itemId);
    try {
      const r = await api.post("/marketplace/redeem", { item_id: itemId, coupon_code: couponCode });
      setShowRedemptionSuccess(r.data);
      await Promise.all([fetchMarketplace(), fetchAchievements()]);
    } catch (err) {
      alert(fmtErr(err.response?.data?.detail) || "Redemption failed");
    } finally { setRedeeming(null); }
  }, [api, fetchMarketplace, fetchAchievements]);

  return {
    marketplaceData, marketplaceFilter, setMarketplaceFilter, redeeming,
    showMarketplace, setShowMarketplace, showRedemptionSuccess, setShowRedemptionSuccess,
    fetchMarketplace, redeemCoupon,
  };
}
